import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'markdown-to-jsx';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import { availableEditorComponentsSplitView } from './editorComponents/availableEditorComponentsSplitView';

export const HTMLContent = ({ children }) => (
  <div dangerouslySetInnerHTML={{ __html: children }} />
);

export const Content = ({ children, className }) => (
  <MDXRenderer className={className}>{children}</MDXRenderer>
);

export const PreviewContent = ({ children, className }) => (
  <div className={className}>{children}</div>
);

export const PreviewMdxContent = ({ children, className }) => (
  <Markdown
    options={{ overrides: availableEditorComponentsSplitView }}
    className={className}
  >
    {children}
  </Markdown>
);

Content.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Content.defaultProps = {
  className: '',
  children: null,
};

HTMLContent.propTypes = Content.propTypes;
